const day = (value) => value?.slice(0, 10) ?? null;
export function scheduleWindow(schedule, schedules) {
    const next = schedules.filter(s => s.supersedes_schedule_id === schedule.id && ['Current', 'Ended'].includes(s.status) && s.source_mapping?.controlledChangeApprovalId && day(s.effective_from) && day(schedule.effective_from) && day(s.effective_from) > day(schedule.effective_from)).sort((a, b) => day(a.effective_from).localeCompare(day(b.effective_from)))[0];
    const cutoff = next?.effective_from ? new Date(Date.parse(day(next.effective_from) + 'T00:00:00Z') - 86400000).toISOString().slice(0, 10) : null, until = day(schedule.effective_to);
    return { from: day(schedule.effective_from), until: cutoff && (!until || cutoff < until) ? cutoff : until, successorId: next?.id ?? null };
}
export function scheduleCoversPeriod(schedule, schedules, from, until) {
    const window = scheduleWindow(schedule, schedules);
    return ['Current', 'Ended'].includes(schedule.status) && Boolean(window.from && window.from <= from && (!window.until || window.until >= until) && from <= until);
}
export function scheduleDateState(schedule, schedules, today) {
    if (schedule.status === 'Draft')
        return 'Draft';
    if (!['Current', 'Ended'].includes(schedule.status) || !schedule.effective_from)
        return 'Unreviewed';
    const window = scheduleWindow(schedule, schedules);
    return window.from > today ? 'Future' : window.until && window.until < today ? 'Expired' : 'Current';
}
//# sourceMappingURL=schedule-dates.js.map